import { EditorTag } from '../types/editor_tag';
import { DataType } from '../types/data_type';
/**
 * Represents a value editor.
 */
var ValueEditor = /** @class */ (function () {
    /** The default constructor. */
    function ValueEditor() {
        this.id = "";
        this.tag = EditorTag.Unknown;
        this.resType = DataType.Unknown;
        this.defValue = "";
    }
    /**
     * Loads value editor from its JSON representation object.
     * @param data The JSON representation object.
     */
    ValueEditor.prototype.loadFromData = function (data) {
        if (data) {
            this.id = data.id;
            this.tag = data.tag;
            this.defValue = data.defval;
            this.resType = data.rtype;
            this.accept = data.accept;
            this.multiline = data.multiline;
            if (data.subType) {
                this.resType = data.subType;
            }
            if (data.name) {
                this.name = data.name;
            }
            if (data.values) {
                this.values = data.values;
            }
        }
    };
    ValueEditor.prototype.getValueText = function (value) {
        var result = "";
        if (!this.values)
            return result;
        if (Array.isArray(value)) {
            for (var _i = 0, _a = this.values; _i < _a.length; _i++) {
                var item = _a[_i];
                if (value.indexOf(item.id) >= 0) {
                    result += item.text + ',';
                }
            }
        }
        else {
            for (var _b = 0, _c = this.values; _b < _c.length; _b++) {
                var item = _c[_b];
                if (item.id === value) {
                    result += item.text + ',';
                }
            }
        }
        if (result) {
            result = result.substring(0, result.length - 1);
        }
        return result;
    };
    return ValueEditor;
}());
export { ValueEditor };
//# sourceMappingURL=value_editor.js.map